export default "__VITE_ASSET__c45e2fd4__"